import { useSelector } from 'react-redux';

import { useOnboarding } from '@edu-frontend/modules/src/shared/ui/OnboardingModal';
import { getOnboarding } from 'platform-components/src/components/app-factory/selectors';

interface Props {
    id: string;
}

// хук дублируется в von-dyck EDUCATION-44977
export function useBunkerOnboarding({ id: onboardingId }: Props) {
    const onboarding = useSelector((_) => getOnboarding(_, onboardingId));
    return useOnboarding({ id: onboardingId, slides: onboarding?.slides });
}

// ключи онбординга

export const DETECT_PASTE_ONBOARDING_KEY = 'anticheat-coding';
export const TEACHER_RESERVE_LEADERBOARD_ONBOARDING_KEY = 'teacher-reserve-leaderboard';
export const TEACHER_MULTI_ASSIGNMENT_ONBOARDING_KEY = 'teacher-multi-assignment';
export const TEACHER_BETA_LESSONS_ONBOARDING_KEY = 'teacher-beta-lessons';
export const TEACHER_BETA_CLASSES_ONBOARDING_KEY = 'teacher-beta-classes';
